export class CourseProductNameMapper {
  private static readonly byCode: Record<string, string> = {
    en: 'English Core',
    en3: 'English Core 3rd edition',
    'en.bs': 'English for Business',
    sp: 'Spanish Core',
    'en.ch': 'English Children',
  };

  static map(code?: string | null): string {
    if (!code) {
      return '';
    }
    return this.byCode[code] ?? code;
  }
}
